import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import PageNotFound from "../pages/404";
// import User from "../pages/User";
import PrivateRoute from "../components/auth/PrivateRoutes";

import { RDRouter } from "./rd.router";
import { RDDataRouter } from "./rddata.router";

import { ERPDataRouter } from "./erpdata.router";
import { ERPRouter } from "./erp.router";
import {ERPReportRouter} from "./erp.report";

import { PrintRouter } from "./print.route";
import { FileControl } from "../pages/file-control/file-control";

import { User, UserAccess, UserManage } from "../pages/user";
import { PermissionAccess } from "../pages/permission";

import { DashBoard } from "../pages/dashboard";
import { Modules, ModuleMenu } from "../pages/modules";

import { ROLES, LAYOUT } from "../constant/constant";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate replace to="/login" />} />
        <Route path="/login" element={<Login />} />

        <Route
          element={<PrivateRoute allowdRole={[ROLES.ADMIN, ROLES.USER]} />}
        >

          <Route path="/modules" element={<Modules />} />
          <Route path="/modules/:key" element={<ModuleMenu />} />
          <Route path="/dashboard" element={<DashBoard />} />
          <Route path="/file-control" element={<FileControl />} />

          {RDDataRouter}
          {RDRouter}    
          {ERPDataRouter}  
          {ERPRouter}
          {ERPReportRouter}
          
        </Route>

        <Route element={<PrivateRoute allowdRole={[ROLES.ADMIN]} />}>
          <Route path="/user/" exact element={<User />}>
            <Route index element={<UserAccess />} />
            <Route path="manage/:action" element={<UserManage />} />
          </Route>
          <Route path="/permission" element={<PermissionAccess />} />
        </Route>

        <Route
          element={
            <PrivateRoute
              allowdRole={[ROLES.ADMIN, ROLES.USER]}
              layout={LAYOUT.ALOND}
            />
          }
        >
          {PrintRouter}
        </Route>


        <Route path="/*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
